import { __read, __spread } from "tslib";
// @ts-ignore
import { deepmerge as MuiDeepmerge } from '@material-ui/utils';
function deepmerge() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return MuiDeepmerge.apply(void 0, __spread(args));
}
export { deepmerge };
